import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CompanyOffersService } from 'app/company-offers/services/company-offers.service';
import { LoanOfferGenService } from 'app/loan/services/loan-offer-gen.service';
import * as emiGlobals from 'app/globals';
import { EmiBaseInfoService } from 'app/shared/services/emi-base-info.service';
import { HttpService } from 'app/shared/services/http.service';
import { ActivatedRoute } from '@angular/router';
import { ProductOffer } from 'app/calculators/Product';

@Component({
  selector: 'app-loan-application-form',
  templateUrl: './loan-application-form.component.html',
  styleUrls: ['./loan-application-form.component.css']
})
export class LoanApplicationFormComponent implements OnInit {

  portalName: any;
  portalInfo: any;
  userInputValues: string;
  userInpt: any;
  HideOfferName: any;
  PortalHodeOffer: any;
  selectedoffer: any;
  fakeArray = new Array(12);
  minuets: any[];
  p: any;
  InputFieldValue;
  whatsAppText;

  offers: Offers = new Offers();
  productOffer: ProductOffer = new ProductOffer();

  options_gender = emiGlobals.GenderEnum;
  option_workexp = emiGlobals.WorkExperienceEnum;

  @Input() input;
  @Input() whtasAppNumber;
  @Input() offer;
  @Input() Messenger;

  loanApplyForm: FormGroup;

  // Show Form
  showForm: boolean = true;

  // Show Thanks You div
  showThankYou: boolean = false;

  agentInfo = false;

  // We are passing an instance of the FormBuilder to our constructor
  constructor(
    fb: FormBuilder, public httpService: HttpService, private activatedRoute: ActivatedRoute
  ) {

    let p_info = localStorage.getItem('portalInfo');
    if (p_info) {
      this.portalInfo = JSON.parse(p_info);
      this.portalName = 'https://' + this.portalInfo.portal_name + '.eloan.loan';

    }

    this.minuets = ['00', '15', '30', '45'];
    this.p = ['AM', 'PM'];
    // Here we are using the FormBuilder to build out our form.
    this.loanApplyForm = fb.group({
      'name': ['', Validators.compose([Validators.required, Validators.minLength(3)])],
      'email': ['', Validators.compose([Validators.required, Validators.email])],
      'contact_number': ['',
        Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(10)])],
      'contact_at': [new Date()],
      'hour': [9],
      'minuet': ['30'],
      'am_pm': ['AM'],

    });

  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.productOffer.leadId = params['leadId'];

      if (this.productOffer.leadId) {
        this.httpService.getAll(emiGlobals.getLeadDetailsById + '/' + this.productOffer.leadId).subscribe(
          result => {
            this.productOffer.email = result.leads[0].email;
            this.productOffer.contactNumber = result.leads[0].contact_number;
            this.productOffer.name = result.leads[0].name;
          }
        )
      }

    });
    this.selectedoffer = this.offer;
    let selected_offer = 'BankName:' + this.selectedoffer.Bank + ',LoanInterest:' + this.selectedoffer.ROI +
      ',Type:' + 'loans' + ',LoanAmount:' + this.selectedoffer.loanamount +
      ',Emi:' + this.selectedoffer.EMI;
    this.whatsAppText = 'UserInput:[' + (this.userInputValues ? this.userInputValues :
      'default_offer') + ']:::' + ',SelectedOffers:[' + selected_offer + ']' +
      ',:::PortalName:[' + this.portalName + ']';

  }
  submitForm(data: any): void {
    let month;
    let contact;
    let contact_time;

    if (data.contact_at) {
      month = parseInt(data.contact_at.getMonth()) + 1;
      contact = data.contact_at.getDate() + '-' + month + '-' + data.contact_at.getFullYear();
    }
    contact_time = data.hour + ':' + data.minuet + ':' + data.am_pm;
    data.contact_me_at = 'date:' + contact + ' time:' + contact_time;
    delete data.contact_at;
    delete data.hour;
    delete data.minuet;
    delete data.am_pm;
    this.showForm = false;
    this.showThankYou = true;
    this.offers.name = data.name;
    this.offers.email = data.email;
    this.offers.contact_number = data.contact_number;
    this.offers.ROI = this.selectedoffer.ROI;
    this.offers.emi = this.selectedoffer.EMI;
    this.offers.bankId = this.selectedoffer.Bank;
    this.offers.product = this.selectedoffer.product;
    this.offers.company_name = this.selectedoffer.company_name;
    this.offers.processing_fee = this.selectedoffer.PF;
    this.offers.lead_type = 'loans';
    this.offers.salary_bank_id = this.input.salaryAccountBank;
    this.offers.residencyId = this.input.residencyId;
    this.offers.selEmpName = this.input.companyName
    this.offers.gender = this.input.gender
    this.offers.cityId = this.input.locationId

   

    this.input.questionAnswer.forEach(element => {
      if(element.category_id === 1) {
        this.offers.age = element.value;
      } if (element.category_id === 2) {
        this.offers.loanamount = element.value;
      } if (element.category_id === 3) {
        this.offers.tenure = element.value;
      } if (element.category_id === 4) {
        this.offers.salary = element.value;
      } if (element.category_id === 10) {
        this.offers.companyId = element.value;
      } if (element.category_id === 16) {
        this.offers.residencyId = element.value;
      } if(element.category_id ===  12) {
        //this.offers.cityId = element.value;
      } if(element.category_id === 13) {
        // this.offers.gender = element.value;
      } if(element.category_id === 9) {
        this.offers.emi = element.value;
      }
    });

    this.httpService.create(emiGlobals.saveToLeadUrl, this.offers).subscribe(result => {
      const value = JSON.parse(result._body);
    });
  }
}

export class Offers {
  name: any;
  contact_number: any;
  email: any;
  ROI: any;
  loanamount: any;
  emi: any;
  processing_fee: any;
  tenure: any;
  lead_type: any;
  bankId: any;
  product: any;
  salary: any;
  companyId: any;
  company_name: any;
  salary_bank_id: any;
  residencyId: any;
  cityId: any;
  gender: any;
  age:any;
  selEmpName:any;
}



// WEBPACK FOOTER //
// ./src/app/calculators/loan-application-form/loan-application-form.component.ts